import { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';

interface SessionTimeoutProps {
  timeoutMinutes?: number; // Zeit in Minuten bis zum Timeout
}

const SessionTimeout: React.FC<SessionTimeoutProps> = ({ timeoutMinutes = 30 }) => {
  const { logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [lastActivity, setLastActivity] = useState<number>(Date.now());
  
  // Eigener, separater Schlüssel für Session-Timeout
  const SESSION_ACTIVITY_KEY = 'sessionLastActivity';
  
  // Funktion zum Aktualisieren des letzten Aktivitätszeitstempels
  const updateActivity = () => {
    const now = Date.now();
    setLastActivity(now);
    localStorage.setItem(SESSION_ACTIVITY_KEY, now.toString());
  };

  useEffect(() => {
    if (!isAuthenticated) return;

    // Aktivitäts-Events definieren
    const activityEvents = [
      'mousedown', 'mousemove', 'keydown',
      'scroll', 'touchstart', 'click', 'keypress'
    ];
    
    // Event-Listener für Benutzeraktivität hinzufügen
    activityEvents.forEach(event => {
      window.addEventListener(event, updateActivity);
    });
    
    // Letzten Aktivitätszeitstempel aus dem lokalen Speicher abrufen
    const storedLastActivity = localStorage.getItem(SESSION_ACTIVITY_KEY);
    if (storedLastActivity) {
      setLastActivity(parseInt(storedLastActivity, 10));
    } else {
      // Initial setzen, wenn noch nicht vorhanden
      localStorage.setItem(SESSION_ACTIVITY_KEY, Date.now().toString());
    }
    
    // Interval zum Überprüfen der Inaktivität
    const checkInactivity = setInterval(() => {
      const currentTime = Date.now();
      const storedTime = localStorage.getItem(SESSION_ACTIVITY_KEY);
      const lastActivityTime = storedTime ? parseInt(storedTime, 10) : lastActivity;
      const inactiveTime = currentTime - lastActivityTime;
      const timeoutTime = timeoutMinutes * 60 * 1000; // Umrechnung in Millisekunden
      
      if (inactiveTime > timeoutTime) {
        console.log('Sitzung abgelaufen aufgrund von Inaktivität');
        localStorage.removeItem(SESSION_ACTIVITY_KEY);
        logout();
        alert('Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.');
        
        // Zur Anmeldeseite weiterleiten
        navigate('/login');
        
        clearInterval(checkInactivity);
      }
    }, 60000); // Überprüfung jede Minute
    
    // Cleanup-Funktion
    return () => {
      activityEvents.forEach(event => {
        window.removeEventListener(event, updateActivity);
      });
      clearInterval(checkInactivity);
    };
  }, [isAuthenticated, lastActivity, logout, timeoutMinutes, navigate]);
  
  return null; // Diese Komponente rendert nichts
};

export default SessionTimeout;